
import { PropTypes } from 'prop-types';
const Template = ({children}) => {
  return (
    <div className="grid p-4 md:p-8 md:px-12 bg-[#0039CB1A] gap-8 h-fit rounded">
        {children}
    </div>
  )
}
Template.propTypes = {
    children: PropTypes.node.isRequired
}
export default Template